import apiService from './apiService';

export const postHotWorkApproval = async (payload: {}) => {
  try {
    const response = await apiService.post(`hot-work-approvals`, payload);
    return response.data;
  } catch (error) {
    console.error('Error posting hot-work-approvals:', error);
    throw error;
  }
};

export const getHotWorkApproval = async (page: number = 1, search = '') => {
  try {
    const params = new URLSearchParams({ page: String(page) });
    if (search) params.append('filter[search]', search);
    const response = await apiService.get(`hot-work-approvals?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching hot-work-approvals:', error);
    throw error;
  }
};

export const getHotWorkApprovalById = async (id: number | string) => {
  try {
    const response = await apiService.get(`hot-work-approvals/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching hot-work-approval by Id:', error);
    throw error;
  }
};

export const updateHotWorkApproval = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`hot-work-approvals/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating hot-work-approvals by Id:', error);
    throw error;
  }
};

export const deleteHotWorkApproval = async (id: number | string) => {
  try {
    const response = await apiService.delete(`/hot-work-approvals/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting hot-work-approvals by Id:', error);
    throw error;
  }
};

/**
 * POST {hotWorkApproval}/assessment
 *
 * Matches route: Route::post('{hotWorkApproval}/assessment', [HotWorkApprovalWorkflowController::class, 'completeAssessment'])
 *
 * Payload shape (matches backend validation):
 * {
 *   assessment_answers: {
 *     sprinklers_operable: { question_id: 1, question: "Available sprinklers…", checked: true },
 *     hot_work_equipment_good_repair: { question_id: 2, question: "Hot/Work equipment…", checked: false },
 *     ... (one entry per checklist item)
 *   },
 *   other_precautions_taken: "Some notes or empty string"
 * }
 */
export const submitAssessment = async (
  id: number | string,
  payload: {
    assessment_answers: Record<string, { question_id: number; question: string; checked: boolean }>;
    other_precautions_taken: string;
  },
) => {
  try {
    const response = await apiService.post(`hot-work-approvals/${id}/assessment`, payload);
    return response.data;
  } catch (error) {
    console.error('Error submitting hot-work-approval assessment:', error);
    throw error;
  }
};

export const getFireWatchMonitors = async () => {
  try {
    const response = await apiService.get('fire-watch-monitors');
    return response.data;
  } catch (error) {
    console.error('Error fetching fire watch monitors:', error);
    throw error;
  }
};

export const notifyApproval = async (id: number | string, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`hot-work-approvals/${id}/notify-approval`, payload);

    return response.data;
  } catch (error) {
    console.error('Error notifying approval:', error);
    throw error;
  }
};

export const getHotWorkPeople = async () => {
  try {
    const response = await apiService.get('hot-work-approval-peoples-involved');
    return response.data;
  } catch (error) {
    console.error('Error fetching hot work people:', error);
    throw error;
  }
};

export const getAppointedPersons = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=17');

    return response.data;
  } catch (error) {
    console.error('Error fetching appointed persons:', error);
    throw error;
  }
};

export const markApproved = async (id: number | string) => {
  try {
    const response = await apiService.post(`hot-work-approvals/${id}/approve`);
    return response.data;
  } catch (error) {
    console.error('Error approving hot-work-approval:', error);
    throw error;
  }
};

export const rejectApproval = async (id: number | string, remarks: string) => {
  try {
    const response = await apiService.post(`hot-work-approvals/${id}/reject-approval`, { remarks });
    return response.data;
  } catch (error) {
    console.error('Error rejecting hot-work-approval:', error);
    throw error;
  }
};

export const responsiblePersonClearance = async (id: number | string) => {
  try {
    const response = await apiService.post(`hot-work-approvals/${id}/responsible-person-clearance`);

    return response.data;
  } catch (error) {
    console.error('Error marking clearance:', error);
    throw error;
  }
};

export const responsiblePersonCancel = async (id: number | string, remarks: string) => {
  try {
    const response = await apiService.post(`hot-work-approvals/${id}/responsible-person-cancel`, { remarks });

    return response.data;
  } catch (error) {
    console.error('Error cancelling clearance:', error);
    throw error;
  }
};

export const notifyFinalClearance = async (id: number | string, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`hot-work-approvals/${id}/notify-final-clearance`, payload);

    return response.data;
  } catch (error) {
    console.error('Error notifying final clearance:', error);
    throw error;
  }
};

export const appointedPersonClearance = async (id: number | string) => {
  try {
    const response = await apiService.post(`hot-work-approvals/${id}/appointed-person-clearance`);

    return response.data;
  } catch (error) {
    console.error('Error appointed person clearance:', error);
    throw error;
  }
};

export const appointedPersonCancel = async (id: number | string, remarks: string) => {
  try {
    const response = await apiService.post(`hot-work-approvals/${id}/appointed-person-cancel`, { remarks });

    return response.data;
  } catch (error) {
    console.error('Error appointed person cancel:', error);
    throw error;
  }
};

export const getHotWorkPerformers = async () => {
  const response = await apiService.get('/users?filter[user_type_id]=19');
  return response.data;
};

export const getResponsiblePersonsHWA = async () => {
  const response = await apiService.get('/users?filter[user_type_id]=16');
  return response.data;
};

export const postHotWorkPeople = async (payload: any) => {
  try {
    const response = await apiService.post('hot-work-peoples', payload);
    return response.data;
  } catch (error) {
    console.error('Error posting hot-work-peoples:', error);
    throw error;
  }
};

export const updateHotWorkPeople = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`hot-work-peoples/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating hot-work-peoples:', error);
    throw error;
  }
};
export const getHotWorkApprovalDownload = async (id: string | number) => {
  try {
    const response = await apiService.get(`hot-work-approvals/${id}/download`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error downloading hot-work-approval:', error);
    throw error;
  }
};
